import axios from "axios";
import addQuery from "../utils/addQuery";

export const getUsers = (queryParams?: { [k: string]: any }) => {
  const url = addQuery("/users", queryParams);
  return axios.get(url).then((res) => res.data);
};
